import _defineProperty from "/Users/danknasty/linux/Reactive-Resume/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/danknasty/linux/Reactive-Resume/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useState } from 'react';
import { UnstyledButton } from '@mantine/core';
import { getDecadeRange } from './get-decade-range/get-decade-range.js';
import { CalendarHeader } from '../CalendarHeader/CalendarHeader.js';
import useStyles from './YearPicker.styles.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

function YearPicker(_a) {
  var _b = _a,
      className = _b.className,
      styles = _b.styles,
      classNames = _b.classNames,
      value = _b.value,
      onChange = _b.onChange,
      size = _b.size,
      minYear = _b.minYear,
      maxYear = _b.maxYear,
      _b$__staticSelector = _b.__staticSelector,
      __staticSelector = _b$__staticSelector === void 0 ? "YearPicker" : _b$__staticSelector,
      nextDecadeLabel = _b.nextDecadeLabel,
      previousDecadeLabel = _b.previousDecadeLabel,
      preventFocus = _b.preventFocus,
      others = __objRest(_b, ["className", "styles", "classNames", "value", "onChange", "size", "minYear", "maxYear", "__staticSelector", "nextDecadeLabel", "previousDecadeLabel", "preventFocus"]);

  var _useStyles = useStyles({
    size: size
  }, {
    classNames: classNames,
    styles: styles,
    name: __staticSelector
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      decade = _useState2[0],
      setDecade = _useState2[1];

  var range = getDecadeRange(decade);
  var years = range.map(function (year) {
    return /* @__PURE__ */React.createElement(UnstyledButton, {
      key: year,
      onClick: function onClick() {
        return onChange(year);
      },
      disabled: year < minYear || year > maxYear,
      onMouseDown: function onMouseDown(event) {
        return preventFocus && event.preventDefault();
      },
      className: cx(classes.yearPickerControl, _defineProperty({}, classes.yearPickerControlActive, year === value))
    }, year);
  });
  return /* @__PURE__ */React.createElement("div", __spreadValues({
    className: cx(classes.yearPicker, className)
  }, others), /* @__PURE__ */React.createElement(CalendarHeader, {
    label: "".concat(range[0], " \u2013 ").concat(range[range.length - 1]),
    hasPrevious: typeof minYear === "number" ? minYear < range[0] : true,
    hasNext: typeof maxYear === "number" ? maxYear > range[range.length - 1] : true,
    onNext: function onNext() {
      return setDecade(function (current) {
        return current + 10;
      });
    },
    onPrevious: function onPrevious() {
      return setDecade(function (current) {
        return current - 10;
      });
    },
    nextLevelDisabled: true,
    size: size,
    nextLabel: nextDecadeLabel,
    previousLabel: previousDecadeLabel,
    styles: styles,
    classNames: classNames,
    __staticSelector: __staticSelector,
    preventFocus: preventFocus
  }), /* @__PURE__ */React.createElement("div", {
    className: classes.yearPickerControls
  }, years));
}

YearPicker.displayName = "@mantine/dates/YearPicker";
export { YearPicker };